import { getAgentName } from './getAgentName';
import { prepareGaExtra } from './prepareGaExtra';
import { TJsonQuery } from '../../../../../packages/JsonQuery';
import { IOffer } from '../../../../offer';

interface IGetOfferChatSrcParams {
  offer: IOffer | null;
  dates: { checkin: string; checkout: string } | null;
  jsonQuery: TJsonQuery;
  totalOffers: number;
  position: number | null;
  isEarlyAccess?: boolean;
  mlSearchSessionGuid: string | null;
}

export function getOfferChatSrc({
  offer,
  dates,
  totalOffers,
  jsonQuery,
  position,
  isEarlyAccess,
  mlSearchSessionGuid,
}: IGetOfferChatSrcParams): string {
  if (offer) {
    const { user, cianId, dealType, offerType, gaLabel } = offer;

    const companionName = getAgentName(offer);

    const gaExtra = prepareGaExtra({ totalOffers, jsonQuery, mlSearchSessionGuid });

    const gaProducts = JSON.stringify([{ id: offer.id, offerType: 'offer', position: Number(position) }]);

    /* istanbul ignore next */
    return (
      `/dialogs/?hostType=frame&offerId=${cianId}` +
      `&dealType=${dealType}&offerType=${offerType}` +
      `${companionName ? '&companionName=' + encodeURIComponent(companionName) : ''}` +
      `${user?.cianUserId ? '&companionId=' + encodeURIComponent(user?.cianUserId) : ''}` +
      `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
      '&pageType=Listing' +
      `${dates ? '&checkin=' + encodeURIComponent(dates.checkin) : ''}` +
      `${dates ? '&checkout=' + encodeURIComponent(dates.checkout) : ''}` +
      `&gaProducts=${encodeURIComponent(gaProducts)}` +
      `&gaExtra=${encodeURIComponent(gaExtra)}` +
      `${isEarlyAccess ? '&isEarlyAccess=1' : ''}`
    );
  }

  return '/dialogs/?hostType=frame&chatbot=1&source=Listing&pageType=Listing';
}
